import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTickets } from '../../../stores/support.store';
import { toast } from 'react-toastify';
import { MainContext } from '../../../context/main.context';
import { ITicketSupportList } from '../interfaces';
import { getAuthElemStyle } from '../../../common/tools';
import Header from '../../header';
import Footer from '../../footer';
import SupportTicketCreate from '../ticket_create';
import SupportTicket from '../ticket';

const GET_TICKETS_INTERVAL: number = 60000; // 1 минута


export default function SupportTickets() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { toggleLoader, modalContent, settings, setModalContent } = useContext(MainContext);

    const [ ticketList, setTicketList ] = useState<ITicketSupportList[]>([]);

    let intervalId: NodeJS.Timeout | null = null;

    useEffect(() => {
        _getTickets();

        intervalId = setInterval(_getTickets, GET_TICKETS_INTERVAL);

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [ navigate ]);

    const _getTickets = () => {
        toggleLoader(true);

        getTickets().then(res => {
            const result: ITicketSupportList[] = res?.data;

            if (result.length) {
                setTicketList(result);
                return;
            }

            if (settings?.projects?.authType === 'postMessage') {
                setModalContent({
                    component: <SupportTicketCreate firstTicketCreate={true}/>,
                    className: 'support-tickets-modal',
                });
                return;
            }

            navigate(`/support/ticket/create?first=1`);
        }, err => {
            toast.error('GET_TICKETS_ERROR');
            console.error('GET_TICKETS_ERROR', { err })
        }).finally(() => {
            toggleLoader(false);
        });
    }

    const _renderTicketList = useCallback(() => {
        return (
            <div className="support-tickets-list">
                {
                    ticketList.map((elem: ITicketSupportList, index: number) => {
                        const { id, title, createTs, unreadMessageCount } = elem;

                        return (
                            <div
                                key={`${id}_${index}`}
                                className="support-tickets-list-item"
                                onClick={() => {
                                    if (settings?.projects?.authType === 'postMessage') {
                                        setModalContent({
                                            component: <SupportTicket ticketId={id}/>,
                                            className: 'support-tickets-modal'
                                        });
                                        return;
                                    }

                                    navigate(`/support/ticket?id=${id}`);
                                }}
                            >
                                <div className="support-tickets-list-item-left">
                                    <div className="support-tickets-list-item-title">
                                        { title }
                                    </div>
                                    <div className="support-tickets-list-item-date">
                                        { new Date(createTs).toLocaleString() }
                                    </div>
                                </div>
                                {
                                    unreadMessageCount > 0 && (
                                        <div className="support-tickets-list-item-right">
                                            { unreadMessageCount }
                                        </div>
                                    )
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    }, [ ticketList ]);

    const _renderActions = useCallback(() => {
        return (
            <div className="support-tickets-actions">
                <div
                    className="support-tickets-actions-create-btn"
                    onClick={() => {
                        if (settings?.projects?.authType === 'postMessage') {
                            setModalContent({ component: <SupportTicketCreate/>, className: 'support-tickets-modal' });
                            return;
                        }

                        navigate(`/support/ticket/create`)}
                    }
                >
                    {t('support.createTicket')}
                </div>
            </div>
        );
    }, []);

    return (
        <div className="auth support" style={{ background: !modalContent ? '#e8e8e8' : 'unset' }}>
            <div
                className="auth-container"
                style={{
                    background: !modalContent ? '#e8e8e8' : 'unset',
                    minHeight: !modalContent ? 'calc(100vh - 100px)' : '100%',
                }}
            >
                <div
                    className="auth-modal support"
                    style={getAuthElemStyle(settings)}
                >
                    <Header origin="ticketList"/>
                    <div className="support-tickets">
                        {_renderTicketList()}
                        {_renderActions()}
                    </div>
                </div>
            </div>
            {!modalContent && <Footer/>}
        </div>
    );
}